var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSettingNor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.23039,
    y: 3.73039,
    width: 17.54,
    height: 17.54,
    rx: 8.77,
    stroke: "#2E2E30",
    strokeWidth: 1.66
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5804 9.87516C12.4339 10.0251 12.2405 10.1 12.0002 10.1C11.7599 10.1 11.5665 10.0251 11.4199 9.87516C11.2734 9.72527 11.2002 9.53529 11.2002 9.30523C11.2002 9.07168 11.2751 8.87909 11.4249 8.72745C11.5747 8.57582 11.7665 8.5 12.0002 8.5C12.2339 8.5 12.4257 8.57582 12.5755 8.72745C12.7253 8.87909 12.8002 9.07168 12.8002 9.30523C12.8002 9.53529 12.7269 9.72527 12.5804 9.87516ZM12.0002 10.9C11.5584 10.9 11.2002 11.2582 11.2002 11.7V15.7C11.2002 16.1418 11.5584 16.5 12.0002 16.5C12.442 16.5 12.8002 16.1418 12.8002 15.7V11.7C12.8002 11.2582 12.442 10.9 12.0002 10.9Z",
    fill: "#2E2E30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingNor);
export default __webpack_public_path__ + "static/media/ic_setting_nor.d02a247846a9fd731292f141666fae14.svg";
export { ForwardRef as ReactComponent };